// extracted by mini-css-extract-plugin
export var ModulePinpointListModuleListItem2o_El = "Footer-module--ModulePinpointList-module--listItem--2o_El--2ed40";
export var ModulePinpointListModuleToggleIcon2v8cb = "Footer-module--ModulePinpointList-module--toggleIcon--2v8cb--dd4b0";
export var closeButton = "Footer-module--closeButton--c1b4d";
export var contactInfo = "Footer-module--contactInfo--8395a";
export var contactItem = "Footer-module--contactItem--63bfd";
export var cookieInnerWrapper = "Footer-module--cookieInnerWrapper--d460b";
export var cookieWrapper = "Footer-module--cookieWrapper--9d4f9";
export var copyrightWrapper = "Footer-module--copyrightWrapper--2b2ff";
export var gatsbyPluginPageProgress = "Footer-module--gatsby-plugin-page-progress--2ef35";
export var innerWrapper = "Footer-module--innerWrapper--d6b0c Footer-module--padding--8bfe0";
export var mada = "Footer-module--mada--7a503";
export var navList = "Footer-module--navList--af6a8";
export var navListWrapper = "Footer-module--navListWrapper--f3a71";
export var padding = "Footer-module--padding--8bfe0";
export var smallLinks = "Footer-module--smallLinks--da606";
export var tapStory = "Footer-module--tap-story--a201d";
export var top = "Footer-module--top--c7f28";
export var topArrow = "Footer-module--topArrow--7b14b";
export var wrapper = "Footer-module--wrapper--ec4f2";